import { render } from "./TheAposCommandMenu.vue?vue&type=template&id=ca484484"
import script from "./TheAposCommandMenu.vue?vue&type=script&lang=js"
export * from "./TheAposCommandMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"command-menu/ui/apos/components/TheAposCommandMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca484484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca484484', __exports__)) {
    api.reload('ca484484', __exports__)
  }
  
  module.hot.accept("./TheAposCommandMenu.vue?vue&type=template&id=ca484484", () => {
    api.rerender('ca484484', render)
  })

}


export default __exports__